module.exports = __webpack_public_path__ + "static/media/sample5.6912b10e.png";